import { useEffect } from "react";

function setMetaDescription(content: string) {
  let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "description";
    document.head.appendChild(meta);
  }
  meta.content = content;
}

function setCanonical(href: string) {
  let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = href;
}

export function usePageMeta(
  title: string,
  description: string,
  canonical: string
) {
  useEffect(() => {
    const prevTitle = document.title;
    const metaEl = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]'
    );
    const prevDescription = metaEl?.content ?? null;
    const linkEl = document.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]'
    );
    const prevCanonical = linkEl?.href ?? null;

    document.title = title;
    setMetaDescription(description);
    setCanonical(canonical);

    return () => {
      document.title = prevTitle;
      if (prevDescription) setMetaDescription(prevDescription);
      if (prevCanonical) setCanonical(prevCanonical);
    };
  }, [title, description, canonical]);
}